<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-loan__tcustbase}">
      <el-form :inline="true"  :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.custName" placeholder="姓名/企业名称" clearable></el-input>
        </el-form-item>

        <el-form-item>
            <!-- <el-select v-model="dataForm.companyId" filterable clearable placeholder="机构名称"  @change="getId">
              <el-option
                v-for="item in userType"
                :key="item.value"
                :label="item.label"
                :value="item.id"
                >
                </el-option>
            </el-select>
             -->
             <ren-dept-tree v-model="dataForm.companyId" :placeholder="$t('dept.title')" :query="true" ref="tree"></ren-dept-tree>
          </el-form-item>
        <el-form-item>
            <el-date-picker
                    v-model="date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="getTimes"
                    unlink-panels>
            </el-date-picker>
          </el-form-item>
        <el-form-item>
          <el-button @click="getDataList('dept')">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('loan:tcustbase:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item> -->
        
        <!-- <el-form-item>
          <el-button v-if="$hasPermission('loan:tcustbase:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item> -->
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column prop="companyName" label="资金方" header-align="center" align="center"></el-table-column>
        <el-table-column prop="custName" label="姓名/企业名称" header-align="center" align="center">
          <template slot-scope="scope">
            <div style="color: #17B3A3;" @click="lookDetail(scope.row)">{{scope.row.custName}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="idNo" label="证件号" header-align="center" align="center">
          <template slot-scope="scope">
            <div>{{scope.row.idNo}}</div>
            <el-button class="look-idNo" v-if="scope.row.frontUrl && scope.row.backUrl"  type="text" size="small" @click="lookIdNo(scope.row)">查看证件</el-button>
  
          </template>
        </el-table-column>
       
        <el-table-column prop="mobile" label="手机号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="companyType" label="职业" header-align="center" align="center"></el-table-column>
        <el-table-column prop="income" label="月收入" header-align="center" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.income">{{scope.row.income.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="录入日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userStatus" label="三方账户状态" header-align="center" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.userStatus == 'NOT_OPENED'">未开户</div>
            <div v-if="scope.row.userStatus == 'NORMAL'">开户成功</div>
            <div v-if="scope.row.userStatus == 'ACTIVATE_PENDING'">开户失败</div>
            <div v-if="scope.row.userStatus == 'CHECK_PENDING'">开户中</div>
            <div v-if="scope.row.userStatus == 'CANCEL_PENDING'">销户中</div>
            <div v-if="scope.row.userStatus == 'CANCEL'">注销</div>
          </template>
        </el-table-column>
        <el-table-column prop="faceVerifyUrl" label="意愿链接" header-align="center" align="center" show-overflow-tooltip width="140px">
          <template slot-scope="scope">
            <div @click="getUrl(scope.row.faceVerifyUrl)" v-if="scope.row.faceVerifyUrl">
               <div class="cancel_agree">获取链接</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('loan:tcustbase:entering') &&( scope.row.userStatus == 'NORMAL' || payChannelId != 0)"  type="text" size="small" @click="entering(scope.row.id,scope.row)">录入借款订单</el-button>
            <!-- <el-button v-if="$hasPermission('loan:tcustbase:update')"  type="text" size="small" @click="enteringv(scope.row.id)">查看贷款信息</el-button> -->
            <el-button v-if="$hasPermission('loan:tcustbase:update') && (scope.row.userStatus == 'NOT_OPENED' || scope.row.userStatus == 'NORMAL' || scope.row.userStatus == 'CANCEL')"  type="text" size="small" @click="updateHandle(scope.row.id,'modify',scope.row.userStatus)">修改</el-button>
            <el-button v-if="$hasPermission('loan:tcustbase:update') && payChannelId == 0 &&(scope.row.userStatus == 'NOT_OPENED' || scope.row.userStatus == 'ACTIVATE_PENDING' || scope.row.userStatus == 'CANCEL')"  type="text" size="small" @click="updateHandle(scope.row.id)">开三方账户</el-button>
            <el-button v-if="scope.row.userStatus == 'NORMAL' && payChannelId == 0"  type="text" size="small" @click="changeCard(scope.row)">换绑卡</el-button>

            <el-button v-if="scope.row.userStatus == 'NORMAL' && payChannelId == 0" type="text" size="small" @click="signOut(scope.row.id)">销户</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @openAccount="openAccount" @sendValue="handleReceivedValue" @refreshDataList="getDataList" @FSaddOrUpdateCVisible="showEntering()" ></add-or-update>
      <add-or-updatee v-if="addOrUpdateCVisible" ref="addOrUpdatec"  @signedFS="signed = true" ></add-or-updatee>
      <AddOrUpdateev v-if="addOrUpdateCVisiblev" ref="addOrUpdatecv"   ></AddOrUpdateev>
      <!-- 查看证件弹窗 -->
      <el-dialog
      :visible.sync="isLookIdNo">
      <div class="look-title" slot="title">
        <img src="../../../assets/img/证件.png" alt="">
        <span>借款人证件</span>
      </div>
        <div class="look-dialog">
          <div class="left-dialog">
            <div class="title">身份证头像面</div>
            <div class="idNO-img">
              <div class="img-box">
                <img :src="frontUrl" alt="">
              </div>
            </div>
          </div>
          <div class="right-dialog">
            <div class="title">身份证国徽面</div>
            <div class="idNO-img">
              <div class="img-box">
                <img :src="backUrl" alt="">
              </div>
            </div>
            
          </div>
        </div>
  
    </el-dialog>
    <!-- 查看详情弹窗 -->
    <el-dialog
      :visible.sync="isLookDetail"
      title="查看详情"
      @close="qx()">
      <el-form disabled :model="dataForm2"  ref="dataForm2"  :label-width="$i18n.locale === 'en-US' ? '150px' : '150px'">
        <h3>借款人</h3>
        <div v-if="dataForm2.custBaseDTO.borrowerType == 'PERSONAGE'">
          <el-form-item label="身份证">
            <div style="margin-bottom: 30px;">
              <img style="width: 300px; height: 180px;" :src="dataForm2.custBaseDTO.frontUrl" alt="">
            </div>
            <img style="width: 300px; height: 180px;" :src="dataForm2.custBaseDTO.backUrl" alt="">
          </el-form-item>
      <div class="line-box">
      
      <el-form-item label="姓名" prop="custBaseDTO.custName" class="styW">
          <el-input v-model="dataForm2.custBaseDTO.custName" disabled placeholder="请输入"></el-input>
      </el-form-item>
     
      <el-form-item label="证件号码" prop="custBaseDTO.idNo" class="styW">
          <el-input v-model="dataForm2.custBaseDTO.idNo" disabled placeholder="请输入" ></el-input>
      </el-form-item>
      <el-form-item label="证件有效期" prop="custBaseDTO.validityPeriod" class="styW">
          <el-input v-model="dataForm2.custBaseDTO.validityPeriod" disabled placeholder="请输入" ></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="custBaseDTO.mobile" class="styW">
          <el-input v-model="dataForm2.custBaseDTO.mobile" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="学历" prop="custBaseDTO.educationCode" class="styW">
        <el-input v-model="dataForm2.custBaseDTO.educationCode" placeholder="请输入"></el-input>
      </el-form-item>
      
      <el-form-item label="婚姻状态" prop="custBaseDTO.isMarriedCode" class="styW">
        <el-input v-model="dataForm2.custBaseDTO.isMarriedCode" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item  label="子女" prop="custBaseDTO.children" class="styW">
        <el-input-number class="sandh" v-model="dataForm2.custBaseDTO.children" :min="0" :max="10" label="描述文字"></el-input-number>
      </el-form-item>

        
        <el-form-item label="邮箱地址" prop="custBaseDTO.email"  class="styW1">
          <el-input v-model="dataForm2.custBaseDTO.email" placeholder="请输入"></el-input>
        </el-form-item>
        </div>
      </div>
      <div v-if="dataForm2.custBaseDTO.borrowerType == 'ENTERPRISE'"> 
        <el-form-item label="企业名称" prop="custBaseDTO.custName" class="styW">
          <el-input v-model="dataForm2.custBaseDTO.custName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="custBaseDTO.idNo" class="styW">
          <el-input v-model="dataForm2.custBaseDTO.idNo" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="企业法定代表人姓名" prop="custBaseDTO.repName" class="styW">
          <el-input v-model="dataForm2.custBaseDTO.repName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="通讯地址" prop="custBaseDTO.address" class="styW">
          <el-input v-model="dataForm2.custBaseDTO.address" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="custBaseDTO.mobile" style="min-width: 500px;">
          <div style="display: flex;">
            <el-input style="width: 250px;" v-model="dataForm2.custBaseDTO.mobile" placeholder="请输入"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="custBaseDTO.email" class="styW">
          <el-input v-model="dataForm2.custBaseDTO.email" placeholder="请输入"></el-input>
        </el-form-item>
      </div>
      <h3>收款人</h3>
      <div v-if="dataForm2.custBaseDTO.payeeType == 'PERSONAGE'">
        <el-form-item label="收款银行卡号" prop="custBaseDTO.bankCardNo" class="styW">
          <el-input type="number" v-model="dataForm2.custBaseDTO.bankCardNo" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item class="styW" label="银行名称" prop="custBaseDTO.bankName" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
          <el-input v-model="dataForm2.custBaseDTO.bankName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="银行预留手机号" prop="custBaseDTO.bankPhone" class="styW">
          <el-input v-model="dataForm2.custBaseDTO.bankPhone" placeholder="请输入"></el-input>
      </el-form-item>
        <h3>房产信息</h3>
        <div class="line-box">
          <el-form-item label="居住状况" prop="custBaseDTO.liveState"  class="styW">
            <el-input v-model="dataForm2.custBaseDTO.liveState" placeholder="请输入"></el-input>
          </el-form-item>
      
          <el-form-item label="建筑面积m²" prop="custBaseDTO.houseSize"  class="styW">
            <el-input-number class="sandh" v-model="dataForm2.custBaseDTO.houseSize" :min="0"  ></el-input-number>
          </el-form-item>
          <el-form-item label="房产编号" prop="custBaseDTO.houseNo"  class="styW">
            <el-input v-model="dataForm2.custBaseDTO.houseNo" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="现住地址" prop="custBaseDTO.address"  class="sandh">
            <el-input v-model="dataForm2.custBaseDTO.address" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
        <h3>职业信息</h3>
        <div class="line-box">
          <el-form-item  label="工作单位" prop="custBaseDTO.campanyName"  class="sandh">
            <el-input v-model="dataForm2.custBaseDTO.campanyName" placeholder="请输入"></el-input>
          </el-form-item>
     
          <el-form-item label="单位地址" prop="custBaseDTO.campanyAddress"  class="sandh">
            <el-input v-model="dataForm2.custBaseDTO.campanyAddress" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="单位电话" prop="custBaseDTO.jobTitle"  class="styW">
            <el-input v-model="dataForm2.custBaseDTO.jobTitle" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="职业" prop="custBaseDTO.companyType"  class="styW">
            <el-input v-model="dataForm2.custBaseDTO.companyType" placeholder="请输入"></el-input>
          </el-form-item>
     
          <el-form-item label="缴纳社医保" prop="custBaseDTO.shebaoState"  class="styW">
            <el-input v-model="dataForm2.custBaseDTO.shebaoState" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="每月支薪日" prop="custBaseDTO.payDay"  class="styW">
            <el-input-number class="sandh" v-model="dataForm2.custBaseDTO.payDay" :min="1" :max="31" label="描述文字"></el-input-number>
          </el-form-item>
          <el-form-item label="工龄" prop="custBaseDTO.workAge"  class="styW">
            <el-input-number class="sandh" v-model="dataForm2.custBaseDTO.workAge" :min="0" :max="60" label="描述文字"></el-input-number>
          </el-form-item>
          <el-form-item label="月收入" prop="custBaseDTO.income"  class="styW">
            <el-input-number class="sandh" v-model="dataForm2.custBaseDTO.income" :min="0"  ></el-input-number>
          </el-form-item>

          <el-form-item label="收入来源" prop="custBaseDTO.incomeChannel"  class="styW">
            <el-input v-model="dataForm2.custBaseDTO.incomeChannel" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
        <h3>联系人信息</h3>
        <div class="line-box" v-if="dataForm2.custBaseDTO.relationList.length>0">
          <el-form-item label="姓名" prop="custBaseDTO.relationList[0].name"  :rules="{required: true,min: 2,max: 8,pattern: /^[\u4E00-\u9FA5]+$/, message: '请输入正确的姓名',trigger: 'blur'}"  class="styW">
            <el-input v-model="dataForm2.custBaseDTO.relationList[0].name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="关系" prop="custBaseDTO.relationList[0].relationship" :rules="{required: true, message: '请输入正确关系',trigger: 'change'}"  class="styW">
            <el-input v-model="dataForm2.custBaseDTO.relationList[0].relationship" placeholder="请输入"></el-input>

          </el-form-item>
          <el-form-item label="联系电话" prop="custBaseDTO.relationList[0].mobile" :rules="{ required: true, pattern:/^((0\d{2,3}-\d{7,8})|(1[23586794]\d{9}))$/, message: '请输入正确的电话号码', trigger: 'blur' }"  class="styW">
            <el-input v-model="dataForm2.custBaseDTO.relationList[0].mobile" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="备注"  class="styW">
            <el-input v-model="dataForm2.custBaseDTO.relationList[0].remark" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
        <div class="line-box" v-if="dataForm2.custBaseDTO.relationList.length>0">
          <el-form-item label="姓名" prop="custBaseDTO.relationList[1].name" :rules="{required: true,min: 2,max: 8,pattern: /^[\u4E00-\u9FA5]+$/, message: '请输入正确的用户名',trigger: 'blur'}"  class="styW">
            <el-input v-model="dataForm2.custBaseDTO.relationList[1].name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="关系" prop="custBaseDTO.relationList[1].relationship" :rules="{required: true, message: '请输入正确关系',trigger: 'change'}"  class="styW">
            <el-input v-model="dataForm2.custBaseDTO.relationList[1].relationship" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="custBaseDTO.relationList[1].mobile" :rules="{ required: true, pattern:/^((0\d{2,3}-\d{7,8})|(1[23586794]\d{9}))$/, message: '请输入正确的电话号码', trigger: 'blur' }"  class="styW">
            <el-input v-model="dataForm2.custBaseDTO.relationList[1].mobile" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="备注" class="styW">
            <el-input v-model="dataForm2.custBaseDTO.relationList[1].remark" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
      </div>
      <div v-if="dataForm2.custBaseDTO.payeeType == 'ENTERPRISE'">
        <el-form-item label="对公账户银行开户名" prop="custBaseDTO.bankAcctname" class="styW">
          <el-input v-model="dataForm2.custBaseDTO.bankAcctname" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="custBaseDTO.socialCreditCode" class="styW">
          <el-input v-model="dataForm2.custBaseDTO.socialCreditCode" placeholder="请输入" ></el-input>
        </el-form-item>
        <el-form-item label="收款银行账号" prop="custBaseDTO.bankCardNo" class="styW">
          <el-input type="number" v-model="dataForm2.custBaseDTO.bankCardNo" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item class="styW" label="银行名称" prop="custBaseDTO.bankName" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
          <el-input v-model="dataForm2.custBaseDTO.bankName" placeholder="请输入"></el-input>
        </el-form-item>
        <div class="line-box">
          <el-form-item class="styW" label="开户行所在省" prop="custBaseDTO.bankProName" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
            <el-input v-model="dataForm2.custBaseDTO.bankProName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="styW" label="所在市" prop="custBaseDTO.bankCityName" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
            <el-input v-model="dataForm2.custBaseDTO.bankCityName" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
        <el-form-item v-if="dataForm2.custBaseDTO.bankCityName && dataForm2.custBaseDTO.bankName" label="请输入" prop="custBaseDTO.brabankName" class="styW">
          <el-input v-model="dataForm2.custBaseDTO.brabankName" placeholder="请输入"></el-input>
        </el-form-item>
      </div>
      <div v-if="dataForm2.laccountDTO">
        <h3 class="h3">三方支付信息</h3>
        <el-form-item label="ACCP合作银行账户"  class="styW">
          <el-input v-model="dataForm2.laccountDTO.bankAccount"  placeholder="请输入" ></el-input>
        </el-form-item>
        <el-form-item label="user_id"  class="styW">
          <el-input v-model="dataForm2.laccountDTO.userId"  placeholder="请输入" ></el-input>
        </el-form-item>
      </div>
     
        
    </el-form>
      
      <template slot="footer">
        <el-button @click='qx()'>返回</el-button>
      </template>
    </el-dialog>
    <!-- 换绑卡 -->
    <el-dialog
      :visible.sync="isCardVisible"
      @close="closeCard()">
      <div class="card_title" v-if="isSuccess == false">
        <img class="card_img" src="../../../assets/img/card.svg" alt="">
        <div class="title_text">换绑银行卡</div>
      </div>
      <div class="card_title" v-if="isSuccess == true">
        <i class="el-icon-success" style="color: #17B3A3;font-size: 32px;"></i>
        <div class="title_text" style="margin-left: 6px;">换绑成功</div>
      </div>
      <div class="card_content">

        <div class="before_tie" v-if="isSuccess == true">
          <div class="b_title">
            <img class="b_title_img" src="../../../assets/img/brfore_card.svg" alt="">
            <div class="b_title_text">换绑前</div>
          </div>
          <div class="form_item">
            <div class="form_label">银行名称</div>
            <div >{{beforeBankName}}</div>
          </div>
          <div class="form_item">
            <div class="form_label">绑定银行账号</div>
            <div >{{beforeBankCardNo}}</div>
          </div>
          <div class="form_item">
            <div class="form_label">银行预留手机号</div>
            <div >{{beforeBankPhone}}</div>
          </div>
        </div>
        <div class="tie" v-if="isSuccess == false">
          <div class="b_title">
            <div class="b_title_text">换绑前</div>
          </div>
          <div class="form_item">
            <div class="form_label">银行名称</div>
            <div >{{beforeBankName}}</div>
          </div>
          <div class="form_item">
            <div class="form_label">绑定银行账号</div>
            <div >{{beforeBankCardNo}}</div>
          </div>
          <div class="form_item">
            <div class="form_label">银行预留手机号</div>
            <div >{{beforeBankPhone}}</div>
          </div>
        </div>
        <div class="line"></div>
        <div class="tie" v-if="isSuccess == false">
          <div class="b_title">
            <div class="a_title_text">换绑后</div>
          </div>
          <div class="form_item1">
            <div class="form_label">银行名称</div>
            <el-select v-model="afterBankName"  filterable  clearable placeholder="请选择" >
              <el-option
                v-for="(item,index) in llBank"
                :key="index"
                :label="item.label"
                :value="item.label"
                >
              </el-option>
            </el-select>
          </div>
          <div class="form_item1">
            <div class="form_label">绑定银行账号</div>
            <el-input v-model="afterBankCardNo" placeholder="请输入" clearable></el-input>
          </div>
          <div class="form_item1">
            <div class="form_label">银行预留手机号</div>
            <el-input v-model="afterBankPhone" placeholder="请输入" clearable></el-input>
          </div>
          <div class="form_item1">
            <div class="form_label">支付密码</div>
            <div class="passWord-box1">
              <div id="ipt_pwd7" class="ipt_pwd">
                <span  id="LOGPASS2_SHOW7">请输入支付密码</span>
                <input placeholder="请输入支付密码" id="LOGPASS7" class="default input_search" type="password" disabled="disabled" />
                <div id="keyboardBtn7" class="ipt_pwd_rjp default"></div>
              </div>
            </div>
          </div>
          
          <div style="display: flex;justify-content: center;margin-top: 24px;">
            <el-button @click="closeCard()" size="small" style="padding:8px 20px;">{{ $t('cancel') }}</el-button>
            <el-button :disabled="isDisabled" @click="changeCardConfirm()" type="primary" size="small" style="padding:8px 20px;">{{ $t('confirm') }}</el-button>
          </div>
        </div>
        <div class="after_tie" v-if="isSuccess == true">
          <div class="a_title">
            <img class="a_title_img" src="../../../assets/img/card.svg" alt="">
            <div class="a_title_text">换绑后</div>
          </div>
          <div class="form_item">
            <div class="form_label">银行名称</div>
            <div class="form_input">{{afterBankName1}}</div>
          </div>
          <div class="form_item">
            <div class="form_label">绑定银行账号</div>
            <div class="form_input">{{afterBankCardNo1}}</div>
          </div>
          <div class="form_item">
            <div class="form_label">银行预留手机号</div>
            <div class="form_input">{{afterBankPhone1}}</div>
          </div>
        </div>
      </div>
      <div class="card_footer">
        <img style="margin-right: 6px;" src="../../../assets/img/tip.svg" alt="">
        <div>换绑后原绑定银行卡自动解绑。</div>
      </div>
    </el-dialog>
    <!-- 验证码 -->
    <el-dialog
      :visible.sync="changeCodeVisible"
      title="用户更换绑卡验证"
      @close="closeChangeCode()">
      <h4 style="margin-bottom: 39px; margin-left: 30px;">银行预留手机号：{{ bankChangeMobile }}</h4>
      <div class="code-box">
        <div style="margin-left: 30px;">验证码</div>
        <el-input class="code_ipt" v-model="verifyChangeCode"  placeholder="验证码" ></el-input>
        <div>
          <span v-if="isCountdown2 == false" @click="getChangeCode()">{{codeChangeText}}</span>
          <span v-if="isCountdown2 == true">{{ Countdown2 }}s</span>
        </div>
      </div>
      <template slot="footer">
        <el-button @click='closeChangeCode()'>取消</el-button>
        <el-button :disabled="isDisabled" type="primary" @click='codeChangeConfirm()'>继续</el-button>
      </template>
    </el-dialog>
    <el-dialog
      :visible.sync="codeVisible"
      title="开三方账户，绑定手机验证，请输入"
      @close="closeCode()">
      <h4 style="margin-bottom: 39px; margin-left: 30px;">手机号：{{ verifyMobile }}</h4>
      <div class="code-box">
        <div style="margin-left: 30px;">验证码</div>
        <el-input class="code_ipt" v-model="verifyCode"  placeholder="验证码" ></el-input>
        <div>
          <span v-if="isCountdown == false" @click="getCode()">{{codeText}}</span>
          <span v-if="isCountdown == true">{{ Countdown }}s</span>
        </div>
      </div>
      <template slot="footer">
        <el-button @click='closeCode()'>取消</el-button>
        <el-button v-if="bankCodeType == 'mobile' || bankCodeType == 'mobileAndBank'" type="primary" @click='modifyCodeConfirm()'>继续</el-button>
        <el-button v-else type="primary" @click='codeConfirm()'>继续</el-button>
      </template>
    </el-dialog>
    <el-dialog
      :visible.sync="bankCodeVisible"
      title="开三方账户，绑卡验证，请输入"
      @close="closeBankCode()">
      <h4 style="margin-bottom: 39px;margin-left: 30px;">银行预留手机号：{{ bankMobile }}</h4>
      <div class="code-box">
        <div style="margin-left: 30px;">验证码</div>
        <el-input class="code_ipt" v-model="verifyBankCode"  placeholder="验证码" ></el-input>
        <div>
          <span v-if="isCountdown1 == false" @click="getBankCode()">{{bankCodeText}}</span>
          <span v-if="isCountdown1 == true">{{ Countdown1 }}s</span>
        </div>
      </div>
      <template slot="footer">
        <el-button @click='closeBankCode()'>取消</el-button>
        <el-button v-if="bankCodeType == 'bankPhone' || bankCodeType == 'mobileAndBank'" type="primary" @click='modifyConfirm()'>确定</el-button>
        <el-button v-else type="primary" @click='bankCodeConfirm()'>继续</el-button>
      </template>
    </el-dialog>
    <!-- 设置支付密码 -->
    <el-dialog
      :visible.sync="passwordVisible"
      :title="(bankCodeType == 'mobile' || bankCodeType == 'mobileAndBank') ? '请输入密码' : '请设置三方账户支付密码'"
      @close="closePassword()">
      <div>
        <div class="passWord-box">
          <div id="ipt_pwd6" class="ipt_pwd">
            <span id="LOGPASS2_SHOW6">请输入密码</span>
            <input id="LOGPASS6" class="default input_search" type="password" disabled="disabled" />
            <div id="keyboardBtn6" class="ipt_pwd_rjp default"></div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <el-button @click='closePassword()'>取消</el-button>
        <el-button v-if="bankCodeType == 'mobile' || bankCodeType == 'mobileAndBank'" type="primary" @click='mobilePasswordConfirm()'>确定</el-button>
        <el-button v-else type="primary" @click='passwordConfirm()'>确定</el-button>
      </template>
    </el-dialog>
    <el-dialog
      :visible.sync="signOutVisible"
      title="请输入密码"
      @close="closeSignOut()">
      <div>
        <div class="passWord-box">
          <div id="ipt_pwd8" class="ipt_pwd">
            <span id="LOGPASS2_SHOW8">请输入密码</span>
            <input id="LOGPASS8" class="default input_search" type="password" disabled="disabled" />
            <div id="keyboardBtn8" class="ipt_pwd_rjp default"></div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <el-button @click='closeSignOut()'>取消</el-button>
        <el-button type="primary" @click='signOutConfirm()'>确定</el-button>
      </template>
    </el-dialog>
      <!-- <add-or-updateeloan v-if="addOrUpdateCloanVisible" ref="addOrUpdatecloan" @iscodeFS="code = true" ></add-or-updateeloan> -->
      <!--  -->
      <el-card class="box-card" v-if="signed">
               <p>中运交投</p>
               <h3>请通过 短信中链接进行签约</h3>
               <ul>
                 <li><span>手机号   </span> <span>15812345678</span></li>
                 <li><span>借款编号   </span> <span > 01210000001  </span></li>
                 <li><span>签约有效时间   </span> <span> 1小时 </span></li>
               </ul>
               <div class="card-btn">
                  <button @click="signed = false">取消</button> 
                  <button @click="editRecord()">修改借款记录</button>
                  <button @click="signedOK()">
                      已签约去放款
                  </button>
               </div>
          </el-card>
          <!-- 请输入支付密码 -->
          <el-card class="box-card1" v-if="code">
             <p>中运交投</p>
             <p class="p2">请输入支付密码</p>
             <div>
                <div class="input-box">
                <div class="code-item" :class="codeValue.length == 0 && inputFocus ? 'code-item-active' : ''">{{codeValue[0] ? '*' : ''}}</div>
                <div class="code-item" :class="codeValue.length == 1 && inputFocus ? 'code-item-active' : ''">{{codeValue[1] ? '*' : ''}} </div>
                <div class="code-item" :class="codeValue.length == 2 && inputFocus ? 'code-item-active' : ''">{{codeValue[2] ? '*' : ''}}</div>
                <div class="code-item" :class="codeValue.length == 3 && inputFocus ? 'code-item-active' : ''">{{codeValue[3] ? '*' : ''}}</div>
                <div class="code-item" :class="codeValue.length == 4 && inputFocus ? 'code-item-active' : ''">{{codeValue[4] ? '*' : ''}}</div>
                <div class="code-item" :class="codeValue.length >= 5 && inputFocus ? 'code-item-active' : ''">{{codeValue[5] ? '*' : ''}}</div>
                <input 
                  class="input-code"
                  v-model="codeValue"
                  :maxlength="6"
                  type="tel"
                  @blur="codeInputBlur"
                  @focus="codeInputFocus"
                  @input="codeInputChange" />
              </div>
             </div>
            <div class="footer-btn">
              <el-button @click="code = false">取消</el-button>
              <el-button @click="codeOk()">确认</el-button>
            </div>

        </el-card>
        <!-- 提示弹窗 -->
        <el-dialog
          title="提示"
          :visible.sync="isTip"
          width="30%"
          :close-on-click-modal="false" :close-on-press-escape="false"
          >
            <span>{{tipText}}</span>
            <span slot="footer" class="dialog-footer">
              <el-button v-if="isPresentAccount == true  || isPresentCapitalSide == false" @click="isTip = false">取 消</el-button>
              <el-button v-if="isPresentAccount == true"  @click="changeHandle(custBaseId)">修改借款人</el-button>
              <el-button v-if="isPresentAccount == true" type="primary" :disabled="isDisabled" @click="entering1(custBaseId)">继续</el-button>
              <el-button  v-if="isPresentCapitalSide == false" type="primary" :disabled="isDisabled" @click="submitForm()">继续</el-button>
            </span>
        </el-dialog>
   
    </div>
     <!-- 获取链接 -->
        <el-card class="box-card5" v-if="copyUrlStatus">
        <p>中运交投</p>
        <h3>意愿链接</h3>
        <div style="min-height: 60px;">
          {{ willUrl }}
        </div>
        
        <div class="card-btn">
          <button
            @click="
              () => {
                (copyUrlStatus = false)
              }
            "
          >
            取消
          </button>
          <button  class="copybox" :data-clipboard-text="willUrl" @click="copy">复制
          </button>
         
        </div>
      </el-card>
  
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './tcustbase-add-or-update'
import AddOrUpdatee from './tcustbase-add-or-updatee'
import AddOrUpdateeloan from './tcustbase-add-or-updateeloan'
import AddOrUpdateev from './tcustbase-add-or-v'
import Clipboard from 'clipboard';
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      willUrl: '',
      bankCodeType:'',
      copyUrlStatus:false,
      isModify:false,
      changeType:"",
      isDisabled:false,
      payChannelId:'',
      dataForm1:{},
      dataForm2:{
        "custBaseDTO": {
            "id": "",
            "borrowerType": "",
            "userId": "",
            "custName": "",
            "repName": "",
            "verifyId": "",
            "companyId": "",
            "companyName": "",
            "mobile": "",
            "bankPhone": "",
            "idType": "",
            "idNo": "",
            "sex": "",
            "birthday": null,
            "registerProvinceCode": "",
            "registerCityCode": "",
            "registerAreaCode": "",
            "registerAddress": "",
            "provinceCode": "",
            "cityCode": "",
            "areaCode": "",
            "address": "",
            "isMarriedCode": "",
            "educationCode": "",
            "companyType": "",
            "carStatus": "",
            "houseStatus": "",
            "bankCode": "",
            "payeeType": "",
            "bankProName": "",
            "bankCityName": "",
            "brabankName": "",
            "bankAcctname": "",
            "socialCreditCode": "",
            "cnapsCode": "",
            "bankName": "",
            "bankCardNo": "",
            "email": "",
            "frontUrl": "",
            "backUrl": "",
            "validityPeriod": "",
            "createTime": "",
            "creator": null,
            "updateTime": "",
            "updateBy": "",
            "version": "",
            "remark": "",
            "loanInfo": null,
            "liveState": "",
            "houseType": "",
            "houseSize": "",
            "houseNo": "",
            "beginLive": "",
            "campanyMode": "",
            "shebaoState": "",
            "jobTitle": "",
            "payDay": "",
            "workAge": "",
            "income": "",
            "incomeChannel": "",
            "campanyAddress": "",
            "children": "",
            "campanyName": "",
            "relationList": [
                {
                    "id": "",
                    "applyId": "",
                    "type": '',
                    "name": "",
                    "mobile": "",
                    "relationship": "",
                    "createTime": "",
                    "createBy": "",
                    "updateTime": null,
                    "updateBy": "",
                    "version": "",
                    "remark": "",
                    "idNo": "",
                    "frontUrl": null,
                    "backUrl": null,
                    "addr": "",
                    "email": ""
                },
                {
                    "id": "",
                    "applyId": "",
                    "type": '',
                    "name": "",
                    "mobile": "",
                    "relationship": "",
                    "createTime": "",
                    "createBy": "",
                    "updateTime": null,
                    "updateBy": "",
                    "version": "",
                    "remark": "",
                    "idNo": "",
                    "frontUrl": null,
                    "backUrl": null,
                    "addr": "",
                    "email": ""
                }
            ],
            "systemTransactionId": null,
            "tradingTime": null,
            "openDate": "",
            "userStatus": "",
            "txnSeqno": "",
            "userType": "",
            "requestStr": "",
            "responseStr": ""
        },
        "laccountDTO": {
            "id": "",
            "oidPartner": "",
            "userId": "",
            "oidUserno": "",
            "bankAccount": "",
        }
      },
      beforeBankName:'',
      beforeBankCardNo:'',
      beforeBankPhone:'',
      afterBankName:'',
      afterBankCardNo:'',
      afterBankPhone:'',
      afterBankName1:'',
      afterBankCardNo1:'',
      afterBankPhone1:'',
      token:'',
      token1:'',
      token2:'',
      userId:'',
      verifyCode:'',
      verifyChangeCode:'',
      verifyBankCode:'',
      Countdown:'59',
      Countdown1:'59',
      Countdown2:'59',
      codeText:"获取验证码",
      bankCodeText:"获取验证码",
      codeChangeText:"获取验证码",
      bankMobile:'',
      bankChangeMobile:'',
      verifyMobile:'',
      txn_seqno:'',
      txn_seqno1:'',
      custBaseId:null,
      isPresentCapitalSide:false,
      isPresentAccount:false,
      tipText:'',
      isTip:false,
      frontUrl:null,
      backUrl:null,
      isLookIdNo:false,
      isLookDetail:false,
      codeVisible:false,
      bankCodeVisible:false,
      changeCodeVisible:false,
      isSuccess:false,
      passwordVisible:false,
      isCardVisible:false,
      signOutVisible:false,
      code:false,
      isCountdown:false,
      isCountdown1:false,
      isCountdown2:false,
      passwordInstance:'',
      passwordInstance1:'',
      passwordInstance2:'',
      options: {},
      time: 0,
      codeValue: '',
      inputFocus: false,
      signed:false,
      userType:[],
      llBank:[],
      mixinViewModuleOptions: {
        getDataListURL: '/loan/tcustbase/page',
        getDataListIsPage: true,
        exportURL: '/loan/tcustbase/export',
        // /loan/tcustrelationship
        deleteURL: '/loan/tcustrelationship',
        deleteIsBatch: true
      },
      addOrUpdateCVisible:false,
      addOrUpdateCVisiblev:false,
      addOrUpdateCloanVisible:false,//放款确认
      date:'',
      dataForm: {
        id: '',
        companyId:'',

      }
    }
  },
 created(){
  this.$bus.$on('aaa',()=>{
   
    this.addOrUpdateHandle()
  })
  this.$http.get(`/sys/dict/data/list?dataType=llBank`).then(r=>{
      this.llBank = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
    })
    this.$http.get(`/api/trans/channel`).then(r=>{
      this.payChannelId = r.data.data.channel
    })
 },
//  mounted() {
//   this.getFactor()
//  },

  methods:{
    // 获取链接
    getUrl(link_url){
      this.willUrl = link_url
      this.copyUrlStatus = true
    },
    copy() {
				let clipboard = new Clipboard('.copybox')
        
				clipboard.on('success', e => {
					console.log('复制成功')
          this.$message.success('复制成功')
					// 释放内存
					clipboard.destroy()
				})
				clipboard.on('error', e => {
					// 不支持复制
          this.$message.error('该浏览器不支持自动复制')
					// 释放内存
					clipboard.destroy()
				})
        this.copyUrlStatus = false
		},
    updateHandle(id,type,userStatus){
      if(type){
        this.changeType = type
      }else{
        this.changeType = ''
      }
      if(userStatus == 'NORMAL'){
        this.isModify = true
      }else{
        this.isModify = false
      }
      console.log(11221,this.changeType,this.isModify);
      
      this.addOrUpdateHandle(id,type)
    },
    signOutConfirm(){
      this.passwordInstance2.setRandKey(this.options.random_value)
      const password = this.passwordInstance2.getOutputSM() // 国密加密密码
      this.$http.post(`/api/account/cancel-apply`,{
        user_id:this.user_id,
        password:password,
        random_key: this.options.random_key
      }).then(r=>{
        if(r.data.code == 0){
          this.$message({
            type: 'success',
            message: '销户成功!'
          })
          this.signOutVisible = false
          this.getFactor()
          this.getDataList()
        }else{
          this.$message({
            type: 'error',
            message: r.data.msg
          })
        }
      })
    },
    // 销户
    signOut(id){
      this.$confirm('确定销户？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.signOutVisible = true
        this.user_id = id
        this.getFactor()
      })
    },
    changeCard(item){
      this.isCardVisible = true
      this.isSuccess = false
      this.getFactor()
      this.$http.get(`/loan/tcustbase/queryInfoById/${item.id}`).then((res) => {
          if(res.data.code != 0){
            return this.$message.error(res.data.msg)
          }
         this.userId = res.data.data.custBaseDTO.id
         this.beforeBankName = res.data.data.custBaseDTO.bankName
         this.beforeBankCardNo = res.data.data.custBaseDTO.bankCardNo
         this.beforeBankPhone = res.data.data.custBaseDTO.bankPhone
          
      })
    },
    changeCardConfirm(){
      this.afterBankCardNo =  this.afterBankCardNo.trim()
      this.afterBankPhone =  this.afterBankPhone.trim()
      if(!this.afterBankName){
        return this.$message.error('银行名称不能为空')
      }
      if(!this.afterBankCardNo){
        return this.$message.error('银行卡号不能为空')
      }
      if(!this.afterBankPhone){
        return this.$message.error('银行卡预留手机号不能为空')
      }
      this.isDisabled = true
      this.passwordInstance1.setRandKey(this.options.random_value) // 先设置随机key
      const password = this.passwordInstance1.getOutputSM() // 国密加密密码
      this.$http.post(`/api/account/changeCard-apply`,{
        user_id: this.userId,
        bank_name: this.afterBankName,
	      linked_acctno: this.afterBankCardNo,
	      linked_phone: this.afterBankPhone,
        password: password, //支付密码用户设置
        random_key: this.options.random_key //随机因子接口获取

      }).then((res) => {
        this.isDisabled = false
        if(res.data.code != 0){
          return this.$message.error(res.data.msg)
        }
        this.afterBankName1 = this.afterBankName
        this.afterBankCardNo1 = this.afterBankCardNo
        this.afterBankPhone1 = this.afterBankPhone
        this.isCardVisible = false,
        this.changeCodeVisible = true
        this.bankChangeMobile = res.data.data.linked_phone
        this.token2 = res.data.data.token
        this.txn_seqno = res.data.data.txn_seqno
        this.getChangeCode()
      })
     
      
    },
    
    closeCard(){
      this.isCardVisible = false
      this.isSuccess = false
      this.afterBankCardNo = ''
      this.afterBankName = ''
      this.afterBankPhone = ''
      this.passwordInstance1.clearPWD()
    },
    closeCode(){
      this.codeVisible = false
      this.codeText = '获取验证码'
      
    },
    closeChangeCode(){
      this.changeCodeVisible = false
      this.codeChangeText = '获取验证码'
      this.verifyChangeCode = ''
    },
    closeBankCode(){
      this.bankCodeVisible = false
       this.bankCodeText = '获取验证码'
    },
    closePassword(){
      this.passwordVisible = false
      this.passwordInstance.clearPWD()
      this.passwordInstance1.clearPWD()
    },
    closeSignOut(){
      this.signOutVisible = false
      this.passwordInstance2.clearPWD()
    },
    openAccount(userId,type,mobile,bankPhone){
      console.log('userId',userId,type);
      this.bankCodeType = type
      this.userId = userId.id
      
      if(type == 'bankPhone'){
        this.bankMobile = mobile
        this.modifyBankCode()
        
      }else if(type == 'mobile'){
        this.verifyMobile = mobile
        console.log(2222231,this.verifyMobile);
        
        this.getFactor()
        this.passwordVisible = true
      }else if(type == 'mobileAndBank'){
        this.verifyMobile = mobile
        this.bankMobile = bankPhone
        this.getFactor()
        this.passwordVisible = true
      }else if(userId.openAccount == true){
        this.getCode()
      }
     
      
      
      
    },
    getFactor () {
      this.$http.get('/api/trans/getRandom').then(r => {
        if(r.data.code == '0'){
          console.log(r.data.data)
          this.options = r.data.data
          this.passwordInstance = this.initPassword(this.options)
          this.passwordInstance1 = this.initPassword1(this.options)
          this.passwordInstance2 = this.initPassword2(this.options)
        }else{
          this.$message({
            type:"error",
            message:"获取随机因子失败"
          })
        }
        })
    },
    initPassword(options = {}) {
      // eslint-disable-next-line
      const passowrd = new showKeyBord({
        png: "//mpay-static.oss-cn-hangzhou.aliyuncs.com/html/lib/state-secret/img", // 图片路径，用这个就行了，也可以下载到本地
        click_objId: "#keyboardBtn6", // 触发显示键盘的Dom节点Id
        regExp1: "[\\S\\s]", // 输入过程限制的正则，不匹配正则的字符不让输入
        regExp2: "^[\\S\\s]{6,12}$", // 输入完成后的正则，与getValid()对应，判断输入值是否匹配该正则
        Input_texId: "#LOGPASS6", // 接收内容的Dom节点Id
        parent_objId: "#ipt_pwd6", // 将键盘插入到何处的Dom节点Id
        placeholderId: "#LOGPASS2_SHOW6", // span标签的id，该span用于模拟Input_texId的placeholder
        len: "12", // 表示最大允许输入多少个字符[可以不传递]
        keyBordLeft: "-100px",
        keyBordTop: "60px",
        chaosMode: 0, // 混乱模式,0:无混乱;1:打开时乱一次;2:每输入一个字符乱一次,默认值0
        clickStatus: 0, // 按键状态,0:鼠标划过、悬浮时按键无变化;1:鼠标划过、悬浮时按键的颜色变化,默认值0
        titlefont: "安全支付输入",
        backfont: "退 格",
        capsfont: "切换大/小写",
        surefont: "确定",
        isen: false,
        callBack: () => {}, // 密码校验成功回调
        errorCallBack: () => {}, // 密码校验失败回调
        rsaPublicKey: options.rsa_public_content, // RSA加密必须参数，国密加密可不要
        sm2KeyHex: options.sm2_key_hex, // 国密加密必须参数，RSA加密可不要
        license: options.license, // 必须参数
      })
      passowrd.initOptions()
      return passowrd
    },
    initPassword1(options = {}) {
      // eslint-disable-next-line
      const passowrd = new showKeyBord({
        png: "//mpay-static.oss-cn-hangzhou.aliyuncs.com/html/lib/state-secret/img", // 图片路径，用这个就行了，也可以下载到本地
        click_objId: "#keyboardBtn7", // 触发显示键盘的Dom节点Id
        regExp1: "[\\S\\s]", // 输入过程限制的正则，不匹配正则的字符不让输入
        regExp2: "^[\\S\\s]{6,12}$", // 输入完成后的正则，与getValid()对应，判断输入值是否匹配该正则
        Input_texId: "#LOGPASS7", // 接收内容的Dom节点Id
        parent_objId: "#ipt_pwd7", // 将键盘插入到何处的Dom节点Id
        placeholderId: "#LOGPASS2_SHOW7", // span标签的id，该span用于模拟Input_texId的placeholder
        len: "12", // 表示最大允许输入多少个字符[可以不传递]
        keyBordLeft: "-100px",
        keyBordTop: "50px",
        chaosMode: 0, // 混乱模式,0:无混乱;1:打开时乱一次;2:每输入一个字符乱一次,默认值0
        clickStatus: 0, // 按键状态,0:鼠标划过、悬浮时按键无变化;1:鼠标划过、悬浮时按键的颜色变化,默认值0
        titlefont: "安全支付输入",
        backfont: "退 格",
        capsfont: "切换大/小写",
        surefont: "确定",
        isen: false,
        callBack: () => {}, // 密码校验成功回调
        errorCallBack: () => {}, // 密码校验失败回调
        rsaPublicKey: options.rsa_public_content, // RSA加密必须参数，国密加密可不要
        sm2KeyHex: options.sm2_key_hex, // 国密加密必须参数，RSA加密可不要
        license: options.license, // 必须参数
      })
      passowrd.initOptions()
      return passowrd
    },
    initPassword2(options = {}) {
      // eslint-disable-next-line
      const passowrd = new showKeyBord({
        png: "//mpay-static.oss-cn-hangzhou.aliyuncs.com/html/lib/state-secret/img", // 图片路径，用这个就行了，也可以下载到本地
        click_objId: "#keyboardBtn8", // 触发显示键盘的Dom节点Id
        regExp1: "[\\S\\s]", // 输入过程限制的正则，不匹配正则的字符不让输入
        regExp2: "^[\\S\\s]{6,12}$", // 输入完成后的正则，与getValid()对应，判断输入值是否匹配该正则
        Input_texId: "#LOGPASS8", // 接收内容的Dom节点Id
        parent_objId: "#ipt_pwd8", // 将键盘插入到何处的Dom节点Id
        placeholderId: "#LOGPASS2_SHOW8", // span标签的id，该span用于模拟Input_texId的placeholder
        len: "12", // 表示最大允许输入多少个字符[可以不传递]
        keyBordLeft: "-100px",
        keyBordTop: "50px",
        chaosMode: 0, // 混乱模式,0:无混乱;1:打开时乱一次;2:每输入一个字符乱一次,默认值0
        clickStatus: 0, // 按键状态,0:鼠标划过、悬浮时按键无变化;1:鼠标划过、悬浮时按键的颜色变化,默认值0
        titlefont: "安全支付输入",
        backfont: "退 格",
        capsfont: "切换大/小写",
        surefont: "确定",
        isen: false,
        callBack: () => {}, // 密码校验成功回调
        errorCallBack: () => {}, // 密码校验失败回调
        rsaPublicKey: options.rsa_public_content, // RSA加密必须参数，国密加密可不要
        sm2KeyHex: options.sm2_key_hex, // 国密加密必须参数，RSA加密可不要
        license: options.license, // 必须参数
      })
      passowrd.initOptions()
      return passowrd
    },
    qx(){
      this.isLookDetail = false
    },
    getChangeCode(){
      this.codeChangeText = "重新获取"
          this.isCountdown2 = true
          this.Countdown2 = 59
          var countdownInterval2 = setInterval(() => {
            if (this.Countdown2 > 0) {
              this.Countdown2--;
            } else {
              this.isCountdown2 = false
              clearInterval(countdownInterval2);
            }
      }, 1000);
    },
    getCode(){
      console.log(123,this.userId);
      
      this.$http.post(`/api/account/v1/verify-codes?userId=${this.userId}`).then((res) => {
          if(res.data.code != 0){
            return this.$message.error(res.data.msg)
          }
          this.codeVisible = true
          this.token = res.data.data.token
          this.verifyMobile = res.data.data.reg_phone
          this.isCountdown = true
          this.codeText = "重新获取"
          this.Countdown = 59
          var countdownInterval = setInterval(() => {
            if (this.Countdown > 0) {
              this.Countdown--;
            } else {
              this.isCountdown = false
              clearInterval(countdownInterval);
            }
          }, 1000);
      })
      
    },
    modifyCode(){
     this.codeVisible = true
         
          this.isCountdown = true
          this.codeText = "重新获取"
          this.Countdown = 59
          var countdownInterval8 = setInterval(() => {
            if (this.Countdown > 0) {
              this.Countdown--;
            } else {
              this.isCountdown = false
              clearInterval(countdownInterval8);
            }
          }, 1000);
      
    },
    modifyBankCode(){
      console.log(111113,this.userId)
      this.$http.post('loan/api/change-linked-phone/apply',{
          user_id:this.userId,
          new_linked_phone: this.bankMobile
      }).then(({ data: res })=>{
        if(res.code != 0){
           return this.$message.error(res.msg)
        }
        this.bankCodeVisible = true
       if(res.data){
         this.token1 = res.data.token
          this.txn_seqno = res.data.txn_seqno
       }
        this.isCountdown1 = true
        this.bankCodeText = "重新获取"
        
        this.Countdown1 = 59
        var countdownInterval7 = setInterval(() => {
          if (this.Countdown1 > 0) {
            this.Countdown1--;
          } else {
            this.isCountdown1 = false
            clearInterval(countdownInterval7);
          }
        }, 1000);
                
      }).catch(()=>{})
      
    },
    getBankCode(){
      this.$http.post(`/api/account/v1/individual/open?userId=${this.userId}`).then((res) => {
          if(res.data.code != 0){
            return this.$message.error(res.data.msg)
          }
          this.token1 = res.data.data.token
          this.bankMobile = res.data.data.linked_phone
          this.txn_seqno = res.data.data.txn_seqno
          this.bankCodeText = "重新获取"
          this.isCountdown1 = true
          this.Countdown1 = 59
          var countdownInterval1 = setInterval(() => {
            if (this.Countdown1 > 0) {
              this.Countdown1--;
            } else {
              this.isCountdown1 = false
              clearInterval(countdownInterval1);
            }
      }, 1000);
          
      })
      
    },
    codeChangeConfirm(){
      this.isDisabled = true
      this.$http.post(`/api/account/changeCard-verify`,{
	      token: this.token2,
	      txn_seqno: this.txn_seqno,
	      user_id: this.userId,
	      verify_code: this.verifyChangeCode
      }).then((res) => {
        this.isDisabled = false
        if(res.data.code != 0){
          return this.$message.error(res.data.msg)
        }
        this.$message.success(res.data.msg)
        this.changeCodeVisible = false
        this.isCardVisible = true
        this.isSuccess = true
        this.getDataList()
      })
    },
    codeConfirm(){
      this.$http.post(`/api/account/v1/verify-codes/confirmation`,{
        userId : this.userId,
        verifyCode : this.verifyCode,  //用户填写
        token: this.token //第一个接口返回
      }).then((res) => {
        if(res.data.code != 0){
          return this.$message.error(res.data.msg)
        }
        
        this.codeVisible = false
      this.bankCodeVisible = true
      this.getBankCode()
      })
      
    },
    modifyCodeConfirm(){
      this.$http.post(`loan/api/change-reg-phone/verify`,{
        user_id : this.userId,
        verify_code_new : this.verifyCode,  //用户填写
        token: this.token ,
        txn_seqno : this.txn_seqno1,  
      }).then((res) => {
        if(res.data.code != 0){
          return this.$message.error(res.data.msg)
        }
        this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.codeVisible = false
               this.verifyCode = ''
                if(this.bankCodeType == 'mobileAndBank'){
                   this.modifyBankCode()
                }else{
                  this.getDataList()
                }
                
              }
            })
        
      })
    },
    bankCodeConfirm(){
      this.getFactor()
      this.bankCodeVisible = false
      this.passwordVisible = true
    },
    modifyConfirm(){
       this.$http.post(`loan/api/change-linked-phone/verify`,{
        token: this.token1,
        txn_seqno: this.txn_seqno,
        user_id: this.userId, 
        verify_code_new: this.verifyBankCode, 

      }).then((res) => {
        if(res.data.code != 0){
          return this.$message.error(res.data.msg)
        }
        this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.verifyBankCode = ''
                this.bankCodeVisible = false
                this.getDataList()
              }
            })
      })
    },
    mobilePasswordConfirm(){
      this.passwordInstance.setRandKey(this.options.random_value)
      const password = this.passwordInstance.getOutputSM() // 国密加密密码
      this.$http.post(`loan/api/change-reg-phone/apply`,{
        user_id: this.userId,
        reg_phone_new:this.verifyMobile,
        password: password, //支付密码用户设置
        random_key: this.options.random_key //随机因子接口获取

      }).then((res) => {
          if(res.data.code != 0){
            return this.$message.error(res.data.msg)
          }
           this.token = res.data.data.token
           this.txn_seqno1 = res.data.data.txn_seqno
          this.$message({
            type:"success",
            message:res.data.msg,
            duration: 500,
            onClose: () => {
              this.passwordVisible = false
              this.modifyCode()
              
            }
          })
      })
    },
    passwordConfirm(){
      this.passwordInstance.setRandKey(this.options.random_value)
      const password = this.passwordInstance.getOutputSM() // 国密加密密码
      this.$http.post(`/api/account/v1/individual/verify`,{
        user_id: this.userId,
        txn_seqno: this.txn_seqno,
        verify_code: this.verifyBankCode,  //用户填写
        token: this.token1, //第三个接口返回
        password: password, //支付密码用户设置
        random_key: this.options.random_key //随机因子接口获取

      }).then((res) => {
          console.log(23,res);
          if(res.data.code != 0){
            return this.$message.error(res.data.msg)
          }
          this.$message({
            type:"success",
            message:res.data.msg,
            duration: 500,
            onClose: () => {
              this.verifyBankCode = ''
              this.verifyCode = ''
              this.passwordVisible = false
              this.getDataList()
                    
            }
          })
      })
    },
    handleReceivedValue(value,data){
      console.log(7777,data);
      if(data){
        this.dataForm1 = data
      }
      
      if(value != null){
        this.isTip = true
      }     
      this.isPresentCapitalSide = value.isPresentCapitalSide
      this.isPresentAccount = value.isPresentAccount
      this.tipText = value.message
      this.custBaseId = value.custBaseId
      console.log(666,value);
    },
    changeHandle(custBaseId){
      this.addOrUpdateHandle(custBaseId)
      this.isTip = false
    },
    submitForm(){
      this.isDisabled = true
              this.$http[!this.dataForm1.id ? 'post' : 'put']('/loan/tcustbase/', this.dataForm1).then(({ data: res }) => {
                
                if (res.code !== 0) {
                  return this.$message.error(res.msg)
                }
          
                this.$message({
                  message: this.$t('prompt.success'),
                  type: 'success',
                  duration: 500,
                  onClose: () => {
                    this.isTip = false
                    this.getDataList()
                  }
                })
              }).catch(() => {})
              .finally(() => {
                this.isDisabled = false
              })
    },
    // 查看详情
    lookDetail(item){
      console.log(555,item);
      this.isLookDetail = true
      this.$http.get(`/loan/tcustbase/queryInfoById/${item.id}`).then((res) => {
          console.log(23,res.data.data);
          if(res.data.code != 0){
            return this.$message.error(res.data.msg)
          }
          this.dataForm2 = res.data.data
          console.log(3232,this.dataForm2);
          
      })
    },
    // 查看证件
    lookIdNo(item){
      
      this.isLookIdNo = true
      this.frontUrl = item.frontUrl
      this.backUrl = item.backUrl
      // this.$http.get(`/api/loan/sign/showCommonBorrow?id=${item.id}`).then((res) => {
      //     console.log(23,res);
      // })
     
    },
    editRecord(){
      this.signed = false
      this.entering()
    },
    deldeda(){
    },
    // 支付密码
    codeOk(){
      this.code = false
      this.$router.push({
        path:'/loan-tloanapply',
      })
      console.log(this.codeValue)
    },
    getVerifyCode() {
      this.time = 120;
      const timer = setInterval(() => {
        this.time --;
        if (this.time <= 0) {
          this.time = 0;
          clearInterval(timer);
        }
      }, 1000);
    },
    // 验证码输入框input
    codeInputChange() {
      if (this.codeValue && this.codeValue.length >= 6) {
        // do soming...
      }
    },
    // 验证码输入框失去焦点
    codeInputBlur() {
      this.inputFocus = false;
    },
    // 验证码输入框获取到焦点
    codeInputFocus() {
      this.inputFocus = true;
    },
    // 列表的录入
    entering(id,row){
      if(!row.validityPeriod && row.borrowerType == 'PERSONAGE'){
        this.$message({
          message: '借款人身份证有效期为空，请通过”修改借款人“操作来获取。',
          type: 'error'
        })
        
      }else{
        this.isDisabled = true
        this.addOrUpdateCVisible = true
        this.isTip = false
      
        this.$nextTick(()=>{
          this.$refs.addOrUpdatec.infoid = id
          this.$refs.addOrUpdatec.getFormData()
          this.isDisabled = false
      
        })
      }
     
    },
    entering1(id){
       this.isDisabled = true
        this.addOrUpdateCVisible = true
        this.isTip = false
      
        this.$nextTick(()=>{
          this.$refs.addOrUpdatec.infoid = id
          this.$refs.addOrUpdatec.getFormData()
          this.isDisabled = false
      
        })
     
    },
    
    // 查看
    // enteringv(id){
    //   this.addOrUpdateCVisiblev = true
      
    //   this.$nextTick(()=>{
    //     this.$refs.addOrUpdatecv.infoid = id
    //    this.$refs.addOrUpdatecv.getFormData()
      
    //  })
    // },
     // 签约成功跳转页面到签约成功
     signedOK(){
      this.signed = false
      this.addOrUpdateCloanVisible = true
      this.$refs.addOrUpdatecloan.dialogVisibleok = true
      this.$nextTick(()=>{
        this.$refs.addOrUpdatecloan.dialogVisibleok = true
      })
      },
    showEntering(){
     this.addOrUpdateCVisible = true
     this.$nextTick(()=>{
      this.$refs.addOrUpdatec.dialogVisible = true
     })
    
     
    },
    getTimes() {
        if (this.date != null) {
          this.dataForm.startDate = this.date[0]
          this.dataForm.endDate = this.date[1]
        }else{
          this.dataForm.startDate =''
          this.dataForm.endDate = ''
        }
      }
  },
  watch:{
      $route:{
        handler(newVal,odlVal){
            this.dataForm.companyId = ''
            if(this.$refs.tree){
              this.$refs.tree.showDeptName = ''
            }
            // this.getDataList()
           
        },
        deep:true,
        immediate:true
      }
   },
  components: {
    AddOrUpdate,
    AddOrUpdatee,
    AddOrUpdateeloan,
    AddOrUpdateev,

    
  }
}
</script>

<style lang="scss" scoped>
.box-card5 {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  transform: translate(66px, -140px);

  width: 600px !important;
  height: 380px;
  text-align: center;
  z-index: 999999999999;
  h3 {
    margin: 30px;
  }
  .card-btn {
    width: 60%;
    margin: 60px auto;
  }
  .footer-btn {
    height: 50px;
    width: 100%;
    display: flex;
    margin: 80px 0;

    justify-content: space-around;
  }
  // p:nth-child(2) {
  //   margin: 130px 0;
  //   span {
  //     color: blue;
  //   }
  // }
  // ul {
  //   width: 100%;
  //   margin: 30px 0;
  //   padding-left: 168px;

  //   li {
  //     width: 100%;
  //     text-align: left;
  //     margin: 5px 0;
  //     span:nth-child(1) {
  //       width: 100px !important;
  //     }
  //     span {
  //       font-size: 12px;
  //       display: inline-block;
  //       text-align: left;
  //     }
  //   }
  // }
}
.box-card{
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      width: 500px;
      height: 380px;
      text-align: center;
     h3{
      margin: 30px;
     }
     .card-btn{
      margin: 60px auto;
     }
      .footer-btn{
          height: 50px;
          width: 100%;
          display: flex;
          margin: 80px 0;
          justify-content: space-around;
          }
      p:nth-child(2){
          margin: 130px 0;
          span{
              color: blue;
          }
          
      }
    ul{
        width: 100%;
        margin: 30px 0;
        padding-left:168px ;
        
        li{
            width: 100%;
            text-align: left;
            margin: 5px 0;
            span:nth-child(1){
                width: 100px !important;
            }
            span{
                font-size: 12px;
                display: inline-block;
                text-align: left;
            }
            
        }
    }
  }
  .card-btn{
      display: flex;
      width: 82%;
      margin: 0 auto;
      justify-content: space-between;
      button{
          border: none;
          background: #3B46C4;
          width: 90px;
          height: 40px;
          border-radius: 4px;
          font-weight: 900;
          color: #fff;
      }
  }
  
  .mo{
      width: 200px;
      margin: 20px auto;
      height: 35px;
      line-height: 35px;
      background: #E9EAFA;
      border-radius: 4px;
      color: #3D4090;
      >span{
        background: #E9EAFA;
      }
    }
.box-card1{
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 500px;
  height: 380px;
  text-align: center;
  .p2{
    margin: 20px 0;
  }
  .footer-btn{
    height: 50px;
    width: 100%;
    display: flex;
    margin: 60px 0;
    justify-content: space-around;
  }
}

.input-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 80px;
    position: relative;
    padding: 0px 15px;
    box-sizing: border-box;
    .input-code {
      width: 100%;
      height: 50px;
      position: absolute;
      left: 0px;
      top: 0px;
      box-sizing: border-box;
      color: transparent;
      background-color: transparent;
      opacity: 0;
    }
    .code-item {
      width: 40px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      border-bottom: 1px solid#D8D8D8;
      margin-right: 10px;
      color: #444;
      font-size: 34px;
    }
    .code-item-active {
      border-bottom: 1px solid#F23026;
    }
  }
 .v-modal{
  display: none !important;
 }
 .look-idNo{
  border: 1px solid;
  padding: 2px 5px;
 }
 .look-dialog{
  display: flex;
  justify-content: space-around;
  font-size: 26px;
  color: #8c8c8c;
  .img-box{
    width: 300px;
    height: 200px;
    // border: 1px solid;
    img{
      width: 100%;
      height: 100%;
    }
   
  }
  .title{
    text-align: center;
  }
  .idNO-img{
    margin: 50px 0;
  }
 }
 .look-title{
  display: flex;
  align-items: center;
  img{
    width: 40px;
    margin-right:20px ;
  }
  span{
    color: #8c8c8c;
    font-size: 28px;
    font-weight: bold;
  }
 }
 .styW{
  width: 400px;
}
.h3{
  margin: 20px 0;
 }
 .code-box{
  display: flex;
  align-items: center;
  .code_ipt{
    width: 200px;
    margin: 0 20px;
  }
 }
 .ipt_pwd {
  width: 245px;
  height: 37px;
  position: relative;
  // border: 1px solid #333;
  margin-right: 20px;
}
.passWord-box{
  border:2px solid #ccc ;
  border-radius: 15px;
  width: 300px;
  margin: 20px auto;
  margin-bottom: 30px;
  padding-left: 20px;
}
.card_title{
  display: flex;
  align-items: center;
  justify-content: center;
  .card_img{
    width: 35px;
    margin-right: 10px;
  }
  .title_text{
    color: #333;
    font-weight: bold;
    font-size: 24px;
  }
}
.card_content{
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 50px auto;
  .a_title_text{
        font-weight: bold;
        font-size: 18px;
        color: #17b3a3;
  }
  .b_title_text{
        font-weight: bold;
        font-size: 18px;
        color: #333;
  }
  .form_item1{
    display: flex;
    align-items: center;
    margin: 11px 20px;
    .form_label{
      font-weight: bold;
      color: #333;
      width: 110px;
      // border: 1px solid;

    }
    .el-input{
      width: 200px;
    }
  }
  .form_item{
    display: flex;
    align-items: center;
    margin:40px 20px;
    .form_label{
      font-weight: bold;
      color: #333;
      width: 110px;
      

    }
    .form_input{
      color: #f59a23;
    }
    

  }
  .line{
    height: 350px;
    width: 1px;
    background-color: #333;
    margin: 0 30px;
  }
  .tie{
    height: 350px;
    width: 350px;
  }
  .before_tie{
    background-color: #f2f2f2;
    height: 350px;
    width: 350px;
    
  }
  .b_title{
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px auto;
      .b_title_img{
        width: 24px;
        margin-right: 8px;
      }
      
    }
  .after_tie{
    background-color: rgba(23, 179, 163, 0.05);
    height: 350px;
    width: 350px;
    
  }
  .a_title{
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px auto;
      .a_title_img{
        width: 24px;
        margin-right: 8px;
      }
      
    }
}
.card_footer{
  display: flex;
  align-items: flex-start;
  margin-left: 50px;
}
.passWord-box1{
  border:1px solid #ccc ;
  border-radius: 4px;
  width: 200px;
  padding-left: 16px;
}
.cancel_agree{
  margin-top: 6px;
  border: 1px solid #34c0af91;
  color: #2cb3a3;
  background-color:   #34c0af4a;
  border-radius: 5px;
  padding: 2px 16px 0;
  box-sizing: border-box;
  display: inline-block;
  cursor: pointer;
 }
// .ipt_pwd {
//   width: 245px;
//   height: 37px;
//   position: relative;
//   // border: 1px solid #333;
//   margin-right: 20px;
// }
</style>
